import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MainLayoutComponent } from './shared/layout/app-layouts/main-layout.component';
import { AuthLayoutComponent } from './shared/layout/app-layouts/auth-layout.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: './features/auth/login/login.module#LoginModule',
    data: { pageTitle: "Login" }
  },
  {
    path: 'main',
    loadChildren: './features/main/main.module#MainModule',
    data: { pageTitle: "Home" }
  },
  {
    path: 'egov/callback',
    loadChildren: './features/auth/eGOV-callback/eGOV-callback.module#eGOVCallbackModule',
    data: { pageTitle: "eGOV" }
  },
  // {
  //   path: "",
  //   component: MainLayoutComponent,
  //   children: [
  //     {
  //       path: "",
  //       redirectTo: "home",
  //       pathMatch: "full"
  //     },
  //     {
  //       path: "home",
  //       loadChildren: "./features/home/home.module#HomeModule"
  //     }
  //   ]
  // },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: './features/auth/auth.module#AuthModule',
    data: { pageTitle: "Auth" }
  },
  //the below enables adhoc search. for now it is not needed
  // {
  //   path: "guest",
  //   loadChildren: "./features/splash/splash.module#SplashModule"
  // },
  { path: '**', redirectTo: 'miscellaneous/error404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
